// Auto generated file, do not manually modify!
// com.hotpads.hotpadsapi.api.hp.webapi.v3.handler.search.HpApiSearchV3Handler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  HpApiSearchV3Handler_dots,
  HpApiSearchV3Handler_dots_Path,
  HpApiSearchV3Handler_filterMetadata,
  HpApiSearchV3Handler_filterMetadata_Path,
  HpApiSearchV3Handler_listings,
  HpApiSearchV3Handler_listings_Path,
  HpApiSearchV3Handler_slugs,
  HpApiSearchV3Handler_slugs_Path,
} from '@zg-rentals/ts-hotpads-api-client';

import type {
  HpApiResponseDto,
  HpFilterMetadataResponseDto,
  HpSearchDotsRequestDto,
  HpSearchDotsResponseDto,
  HpSearchListingsRequestDto,
  HpSearchListingsResponseDto,
  HpSearchSlugRegistryDto,
} from '@zg-rentals/ts-hotpads-api-client';

export type HpApiSearchV3Handler_dots_Options = UseQueryOptions<
  HpApiResponseDto<HpSearchDotsResponseDto>,
  unknown,
  HpApiResponseDto<HpSearchDotsResponseDto>,
  readonly [string, HpSearchDotsRequestDto]
>;

const HpApiSearchV3Handler_dots_GetKey = (postData: HpSearchDotsRequestDto) =>
  [HpApiSearchV3Handler_dots_Path, postData] as const;

export const HpApiSearchV3Handler_dots_queryOptions = (
  postData: HpSearchDotsRequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: HpApiSearchV3Handler_dots_GetKey(postData),
    queryFn: () => HpApiSearchV3Handler_dots(postData, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Returns dot map listings for resolved V3 search filters
 */
export const useHpApiSearchV3Handler_dots = (
  postData: HpSearchDotsRequestDto,
  {
    httpClient,
    ...options
  }: Omit<HpApiSearchV3Handler_dots_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...HpApiSearchV3Handler_dots_queryOptions(postData, { httpClient }),
    ...options,
  });
};
useHpApiSearchV3Handler_dots.getKey = HpApiSearchV3Handler_dots_GetKey;

export type HpApiSearchV3Handler_filterMetadata_Options = UseQueryOptions<
  HpApiResponseDto<HpFilterMetadataResponseDto>,
  unknown,
  HpApiResponseDto<HpFilterMetadataResponseDto>,
  readonly [string]
>;

const HpApiSearchV3Handler_filterMetadata_GetKey = () => [HpApiSearchV3Handler_filterMetadata_Path] as const;

export const HpApiSearchV3Handler_filterMetadata_queryOptions = ({ httpClient }: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: HpApiSearchV3Handler_filterMetadata_GetKey(),
    queryFn: () => HpApiSearchV3Handler_filterMetadata(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Returns the filter sections clients render; search request selections reference their keys
 */
export const useHpApiSearchV3Handler_filterMetadata = ({
  httpClient,
  ...options
}: Omit<HpApiSearchV3Handler_filterMetadata_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {}) => {
  return useQuery({
    ...HpApiSearchV3Handler_filterMetadata_queryOptions({ httpClient }),
    ...options,
  });
};
useHpApiSearchV3Handler_filterMetadata.getKey = HpApiSearchV3Handler_filterMetadata_GetKey;

export type HpApiSearchV3Handler_listings_Options = UseQueryOptions<
  HpApiResponseDto<HpSearchListingsResponseDto>,
  unknown,
  HpApiResponseDto<HpSearchListingsResponseDto>,
  readonly [string, HpSearchListingsRequestDto]
>;

const HpApiSearchV3Handler_listings_GetKey = (postData: HpSearchListingsRequestDto) =>
  [HpApiSearchV3Handler_listings_Path, postData] as const;

export const HpApiSearchV3Handler_listings_queryOptions = (
  postData: HpSearchListingsRequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: HpApiSearchV3Handler_listings_GetKey(postData),
    queryFn: () => HpApiSearchV3Handler_listings(postData, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Unified search endpoint - returns listings, resolved slug, canonical URL, and SEO
 */
export const useHpApiSearchV3Handler_listings = (
  postData: HpSearchListingsRequestDto,
  {
    httpClient,
    ...options
  }: Omit<HpApiSearchV3Handler_listings_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...HpApiSearchV3Handler_listings_queryOptions(postData, { httpClient }),
    ...options,
  });
};
useHpApiSearchV3Handler_listings.getKey = HpApiSearchV3Handler_listings_GetKey;

export type HpApiSearchV3Handler_slugs_Options = UseQueryOptions<
  HpApiResponseDto<HpSearchSlugRegistryDto>,
  unknown,
  HpApiResponseDto<HpSearchSlugRegistryDto>,
  readonly [string]
>;

const HpApiSearchV3Handler_slugs_GetKey = () => [HpApiSearchV3Handler_slugs_Path] as const;

export const HpApiSearchV3Handler_slugs_queryOptions = ({ httpClient }: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: HpApiSearchV3Handler_slugs_GetKey(),
    queryFn: () => HpApiSearchV3Handler_slugs(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Returns the search slug registry for validation, display, and redirects
 */
export const useHpApiSearchV3Handler_slugs = ({
  httpClient,
  ...options
}: Omit<HpApiSearchV3Handler_slugs_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {}) => {
  return useQuery({
    ...HpApiSearchV3Handler_slugs_queryOptions({ httpClient }),
    ...options,
  });
};
useHpApiSearchV3Handler_slugs.getKey = HpApiSearchV3Handler_slugs_GetKey;
